export const SUPPORTED_LANGUAGES = ["en", "fr", "es"];

export const LANGUAGE_NAMES = {
  en: "English",
  fr: "French",
  es: "Spanish",
};

export const detectBrowserLanguage = () => {
  if (typeof navigator === "undefined") {
    return "en";
  }

  const candidates = [navigator.language, ...(navigator.languages || [])]
    .filter(Boolean)
    .map((value) => value.toLowerCase());

  for (const candidate of candidates) {
    const language = candidate.split("-")[0];
    if (SUPPORTED_LANGUAGES.includes(language)) {
      return language;
    }
  }

  return "en";
};

export const getPathLanguage = (pathname = "") => {
  const segment = pathname.split("/").filter(Boolean)[0]?.toLowerCase();
  if (segment === "fr" || segment === "es") {
    return segment;
  }
  return "en";
};

export const withLanguagePrefix = (path, lang) => {
  if (!path || typeof path !== "string") {
    return path;
  }

  if (!lang || lang === "en") {
    return path;
  }

  if (!path.startsWith("/")) {
    return path;
  }

  if (path === `/${lang}` || path.startsWith(`/${lang}/`)) {
    return path;
  }

  if (path.startsWith("/fr/") || path.startsWith("/es/") || path === "/fr" || path === "/es") {
    return path;
  }

  return path === "/" ? `/${lang}` : `/${lang}${path}`;
};

export const stripLanguagePrefix = (path = "") => {
  if (path === "/fr" || path === "/es") {
    return "/";
  }
  if (path.startsWith("/fr/")) {
    return path.replace("/fr", "") || "/";
  }
  if (path.startsWith("/es/")) {
    return path.replace("/es", "") || "/";
  }
  return path;
};

export const withLanguageAssetSuffix = (path, lang) => {
  if (!path || typeof path !== "string" || !lang || lang === "en") {
    return path;
  }

  const [pathWithoutHash, hash = ""] = path.split("#");
  const [pathname, query = ""] = pathWithoutHash.split("?");
  const dotIndex = pathname.lastIndexOf(".");

  if (dotIndex < 0) {
    return `${pathname}-${lang}${query ? `?${query}` : ""}${hash ? `#${hash}` : ""}`;
  }

  const localizedPath = `${pathname.slice(0, dotIndex)}-${lang}${pathname.slice(dotIndex)}`;
  return `${localizedPath}${query ? `?${query}` : ""}${hash ? `#${hash}` : ""}`;
};
